module.exports = __webpack_public_path__ + "img/block_image.583bab25.png";